import { ComuniComponent } from './components/comuni/comuni.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';

import { HttpClientModule } from '@angular/common/http';
import { FormlyHorizontalWrapper } from 'horizontal-wrapper';
import { ComuniModule } from './components/comuni/comuni.module';

@NgModule({
  declarations: [AppComponent,FormlyHorizontalWrapper],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    ComuniModule,
    FormlyModule.forRoot({
      validationMessages: [{ name: 'required', message: 'Questo campo è richisto' }],
      wrappers: [{ name: 'form-field-horizontal', component: FormlyHorizontalWrapper }],
    }),
    FormlyBootstrapModule
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }, ComuniComponent
  ],
  exports: [],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {}
